@if (userService.hasPermission(UserPermission.READ_HOME_ACCOUNT_SETUP)) { @if
(hasMetricChallenges()) {
<app-primary-banner
  title="New: Step-Based Challenges"
  text="Join the fun and get moving—our new customizable step challenges are a fun way to get your whole team active! Build healthy habits, boost movement, and compete together."
  link="/challenges/select"
  linkText="Check it out"
></app-primary-banner>
}
<app-banner
  message="Share your company’s unique sign-up link with your team to help them easily sign-up and create their Aaptiv account."
  buttonText="Company Link"
  [buttonIcon]="ButtonIcon.DOCUMENT"
  (handleButtonClick)="handleCopyLink()"
  [buttonTitle]="companyLink"
  [spacingBottom]="Spacing.MEDIUM"
  data-test-id="home-banner"
></app-banner>
<app-card size="none" data-test-id="home-card">
  <div class="card-header">
    <app-text
      [color]="TextColor.NEUTRAL_8"
      [size]="TextSize.BODY_4"
      [weight]="TextWeight.BOLD"
      data-test-id="home-card-header-text"
    >
      {{ 'home.accountSetup' | translate }}
    </app-text>
  </div>
  <div class="card-content">
    <app-action-collection
      [action]="ButtonType.UTILITY"
      [collection]="adminCollection"
      [titleSize]="TextSize.BODY_2"
      (handleAction)="handleAction($event)"
      data-test-id="home-action-collection"
    ></app-action-collection>
  </div>
</app-card>
<app-dialog [(isOpen)]="emailDialog" data-test-id="home-email-dialog">
  <app-text
    [color]="TextColor.NEUTRAL_8"
    [size]="TextSize.BODY_4"
    [weight]="TextWeight.BOLD"
    [spacingBottom]="TextSpacing.X_SMALL"
  >
    {{ 'common.email' | translate }}
  </app-text>
  <app-text
    [color]="TextColor.NEUTRAL_6"
    [size]="TextSize.BODY_2"
    [weight]="TextWeight.REGULAR"
    [spacingBottom]="TextSpacing.LARGE"
  >
    {{ 'home.accountNotification' | translate }}
  </app-text>
  <app-text
    [color]="TextColor.NEUTRAL_6"
    [size]="TextSize.BODY_0"
    [weight]="TextWeight.REGULAR"
    [spacingBottom]="TextSpacing.X_SMALL"
  >
    {{ 'home.launchEmail' | translate }}
  </app-text>
  <app-text
    [color]="TextColor.NEUTRAL_6"
    [size]="TextSize.BODY_0"
    [weight]="TextWeight.REGULAR"
    [spacingBottom]="TextSpacing.SMALL"
  >
    {{ 'home.launchEmailTop' | translate }}
  </app-text>
  <app-text
    [color]="TextColor.NEUTRAL_6"
    [size]="TextSize.BODY_0"
    [weight]="TextWeight.REGULAR"
    [spacingBottom]="TextSpacing.SMALL"
  >
    {{ 'home.launchEmailAaptive' | translate }}
  </app-text>
  <app-text
    [color]="TextColor.NEUTRAL_6"
    [size]="TextSize.BODY_0"
    [weight]="TextWeight.REGULAR"
    [spacingBottom]="TextSpacing.SMALL"
  >
    {{ 'home.launchEmailAaptiveDetail' | translate : { gymInfo } }}
  </app-text>
  <app-text
    [color]="TextColor.NEUTRAL_6"
    [size]="TextSize.BODY_0"
    [weight]="TextWeight.REGULAR"
    [spacingBottom]="TextSpacing.SMALL"
  >
    {{
      'home.launchEmailCompanyInfo'
        | translate : { companyName, membershipTier }
    }}
  </app-text>
  <app-text
    [color]="TextColor.NEUTRAL_6"
    [size]="TextSize.BODY_0"
    [weight]="TextWeight.REGULAR"
    [spacingBottom]="TextSpacing.NONE"
  >
    {{ 'home.benefitTitle' | translate }}
  </app-text>
  <app-text
    [color]="TextColor.NEUTRAL_6"
    [size]="TextSize.BODY_0"
    [weight]="TextWeight.REGULAR"
    [spacingBottom]="TextSpacing.NONE"
  >
    {{ 'home.benefit1' | translate : { signUpLink } }}
  </app-text>
  <app-text
    [color]="TextColor.NEUTRAL_6"
    [size]="TextSize.BODY_0"
    [weight]="TextWeight.REGULAR"
    [spacingBottom]="TextSpacing.NONE"
  >
    {{ 'home.benefit2' | translate }}
  </app-text>
  <app-text
    [color]="TextColor.NEUTRAL_6"
    [size]="TextSize.BODY_0"
    [weight]="TextWeight.REGULAR"
    [spacingBottom]="TextSpacing.SMALL"
  >
    {{ 'home.benefit3' | translate }}
  </app-text>
  <app-text
    [color]="TextColor.NEUTRAL_6"
    [size]="TextSize.BODY_0"
    [weight]="TextWeight.REGULAR"
    [spacingBottom]="TextSpacing.SMALL"
  >
    {{ 'home.closing' | translate }}
  </app-text>
  <app-text
    [color]="TextColor.NEUTRAL_6"
    [size]="TextSize.BODY_0"
    [weight]="TextWeight.REGULAR"
    [spacingBottom]="TextSpacing.SMALL"
  >
    {{ 'home.closingName' | translate }}
  </app-text>
  <div class="home-email-button">
    <app-button
      [type]="ButtonType.PRIMARY"
      [size]="ButtonSize.SMALL"
      [buttonIcon]="ButtonIcon.DOCUMENT"
      (handleClick)="handleCopyEmail()"
      data-test-id="home-email-button"
    >
      {{ buttonText }}
    </app-button>
  </div>
</app-dialog>
<app-add-users-dialog
  [(isOpen)]="inviteUserDialog"
  data-test-id="home-invite-users"
>
</app-add-users-dialog>
}
